export default "__VITE_ASSET__BoYmPVjB__"